import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCreateFilled = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.77775 4.75022C5.20976 4.75022 4.75 5.20998 4.75 5.77797V18.2222C4.75 18.7902 5.20976 19.25 5.77775 19.25H18.222C18.79 19.25 19.2498 18.7902 19.2498 18.2222V11.1112C19.2498 10.697 19.5856 10.3612 19.9998 10.3612C20.414 10.3612 20.7498 10.697 20.7498 11.1112V18.2222C20.7498 19.6187 19.6184 20.75 18.222 20.75H5.77775C4.38133 20.75 3.25 19.6187 3.25 18.2222V5.77797C3.25 4.38155 4.38133 3.25022 5.77775 3.25022H12.8888C13.303 3.25022 13.6388 3.58601 13.6388 4.00022C13.6388 4.41443 13.303 4.75022 12.8888 4.75022H5.77775Z",
		fill: "#111827"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M19.4393 4.43934C20.0251 5.02513 20.013 5.98705 19.4121 6.58786L11.1444 14.8556C10.5436 15.4564 8.71142 16.3388 8.12563 15.753C7.53984 15.1673 8.42231 13.3351 9.02311 12.7342L17.2908 4.46654C17.8916 3.86573 18.8536 3.85355 19.4393 4.43934Z",
		fill: "#111827"
	})]
});
const ForwardRef = forwardRef(SvgCreateFilled);
export default ForwardRef;
